import PropTypes from 'prop-types';
import path from 'path';
import React from 'react';
import events from 'lib/events';
import EditableTextField from '../components/forms/editableTextField.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {countries} from 'helpers/constants';
import {gallonsToLitres} from 'helpers/dataHelpers';

class VolumeCalculator extends React.Component {
  static defaultProps = {
    poolType: 1,
    beforeFocus: true,
    condition: true,
  };

  static propTypes = {
    intl: intlShape.isRequired,
    beforeFocus: PropTypes.bool,
    condition: PropTypes.bool,
    dataKey: PropTypes.string.isRequired,
    editMode: PropTypes.bool.isRequired,
    group: PropTypes.object,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    poolType: PropTypes.number.isRequired,
    region: PropTypes.string,
    volume: PropTypes.number,
  };

  state = {
    poolShape: 0,
    A: '',
    B: '',
    deepDepth: '',
    diameter: '',
    poolLength: '',
    poolWidth: '',
    shallowDepth: '',
    showCalculationSection: false,
    slopingSides: false,
    volume: '',
    isCA: null,
  };

  componentDidMount() {
    document.body.addEventListener('click', this.outsideClick);
    this.setState({
      isCA: this.props.region && this.props.region === countries.CA,
    }, () => this.setState({volume: this.props.volume}));
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.editMode) {
      this.setState({showCalculationSection: false});
    }
    if (this.props.volume !== nextProps.volume) {
      this.setState({volume: nextProps.volume});
    }

    if (this.props.region !== nextProps.region) {
      this.setState({isCA: nextProps.region && nextProps.region === countries.CA});
    }
  }

  componentWillUnmount() {
    if (this.props.onBlur) {
      this.props.onBlur({datakey: 'volume', value: this.state.volume});
    }

    document.body.removeEventListener('click', this.outsideClick);
  }

  calculationSection = () => {
    if (!this.state.showCalculationSection) {
      return <div/>;
    }
    let fields;

    if (this.state.poolShape === 1) {
      fields = <div className='form-group'>
        <label><FormattedMessage id="quick-calcs.pool-volume.diameter"/> (ft)</label>
        <input className='form-control'
               type='number'
               name='diameter'
               step='0.01'
               onChange={this.internalChange('diameter')}
               value={this.state.diameter}
               required/>
      </div>;
    } else if (this.state.poolShape === 3) {
      fields = <div>
        <div className='form-group'>
          <label>A (ft)</label>
          <input className='form-control'
                 type='number'
                 name='A'
                 step='0.01'
                 onChange={this.internalChange('A')}
                 value={this.state.A}
                 required/>
        </div>
        <div className='form-group'>
          <label>B (ft)</label>
          <input className='form-control'
                 type='number'
                 name='B'
                 step='0.01'
                 onChange={this.internalChange('B')}
                 value={this.state.B}
                 required/>
        </div>
        <div className='form-group'>
          <label><FormattedMessage id="quick-calcs.pool-volume.length"/> (ft)</label>
          <input className='form-control'
                 type='number'
                 name='poolLength'
                 step='0.01'
                 onChange={this.internalChange('poolLength')}
                 value={this.state.poolLength}
                 required/>
        </div>
      </div>;
    } else {
      fields = <div>
        <div className='form-group'>
          <label><FormattedMessage id="quick-calcs.pool-volume.length"/> (ft)</label>
          <input className='form-control'
                 type='number'
                 name='poolLength'
                 step='0.01'
                 onChange={this.internalChange('poolLength')}
                 value={this.state.poolLength}
                 required/>
        </div>
        <div className='form-group'>
          <label><FormattedMessage id="quick-calcs.pool-volume.width"/> (ft)</label>
          <input className='form-control'
                 type='number'
                 name='poolWidth'
                 step='0.01'
                 onChange={this.internalChange('poolWidth')}
                 value={this.state.poolWidth}
                 required/>
        </div>
      </div>;
    }
    return <div className='popover bottom volume-calculator-dropdown'
                style={{
                  display: this.props.editMode && this.state.showCalculationSection ? 'block' : 'none',
                  top: '75px',
                  left: '15px',
                }}>
      <div className='arrow'
           style={{left: '85%'}}/>
      <div className='popover-content'>
        <form onSubmit={this.formSubmit}>
          <div className='form-group'>
            <label><FormattedMessage id="general.pool.types"/></label>
            <select className='form-control'
                    name='poolShape'
                    value={this.state.poolShape}
                    onChange={this.changePoolShape}>
              <option value='0'><FormattedMessage id="quick-calcs.pool-volume.rectangle"/></option>
              <option value='1'><FormattedMessage id="quick-calcs.pool-volume.round"/></option>
              <option value='2'><FormattedMessage id="quick-calcs.pool-volume.oval"/></option>
              <option value='3'><FormattedMessage id="quick-calcs.pool-volume.kidney"/></option>
            </select>
          </div>
          {fields}
          <div className='form-group'>
            <label><FormattedMessage id="quick-calcs.pool-volume.depth.deep"/> (ft)</label>
            <input className='form-control'
                   type='number'
                   name='deepDepth'
                   step='0.01'
                   onChange={this.internalChange('deepDepth')}
                   value={this.state.deepDepth}
                   required/>
          </div>
          <div className='form-group'>
            <label><FormattedMessage id="quick-calcs.pool-volume.depth.shallow"/> (ft)</label>
            <input className='form-control'
                   type='number'
                   name='shallowDepth'
                   step='0.01'
                   onChange={this.internalChange('shallowDepth')}
                   value={this.state.shallowDepth}
                   required/>
          </div>
          <div className='form-group'>
            <div className='checkbox-wrapper'>
              <input type='checkbox'
                     name='slopingSides'
                     onChange={this.toggleSlopingSides}
                     checked={this.state.slopingSides}/>
              <label/>
            </div>
            <label><FormattedMessage id="quick-calcs.pool-volume.sloping"/> &nbsp;</label>
          </div>
          <div className='form-group'>
            <button className='btn btn-primary'
                    type='submit'
                    data-event-category='User'
                    data-event-action='pool-use-volcalc'>
              {this.props.intl.formatMessage({id: 'quick-calcs.calculate'})}
            </button>
          </div>
        </form>
      </div>
    </div>;
  };

  changePoolShape = event => {
    this.setState({poolShape: parseInt(event.target.value)});
  };

  formSubmit = event => {
    event.preventDefault();
    let volume = 0;
    // Parse float necessary because the values were being interpreted as strings
    let averageDepth = (parseFloat(this.state.deepDepth) + parseFloat(this.state.shallowDepth)) / 2;

    if (this.state.poolShape === 0) { // Rectangle
      volume = this.state.poolLength * this.state.poolWidth * averageDepth * 7.5;
    } else if (this.state.poolShape === 1) { // Round
      volume = Math.pow(this.state.diameter, 2) * averageDepth * 5.9;
    } else if (this.state.poolShape === 2) { // Oval
      volume = this.state.poolLength * this.state.poolWidth * averageDepth * 5.9;
    } else if (this.state.poolShape === 3) { // Kidney
      volume = (parseFloat(this.state.A) + parseFloat(this.state.B)) * this.state.poolLength * averageDepth * 7.5 * 0.45;
    }

    if (this.state.slopingSides) {
      volume = volume / 1.15;
    }

    if (this.state.isCA) {
      volume = gallonsToLitres(volume);
    }

    this.setState({showCalculationSection: false});

    events.publish('ga.event', {category: 'System', action: 'pool-shape-' + this.state.poolShape});
    this.saveVolume(volume);
  };

  handleBlur = datakey => {
    return event => {
      if (this.props.onBlur) {
        this.props.onBlur({key: datakey, value: parseInt(event.target.value)});
      }
    };
  };

  handleChange = e => {
    this.setState({volume: parseInt(e.value)});
    if (this.props.onChange) {
      this.props.onChange({key: e.key, value: parseInt(e.value)});
    }
  };

  internalChange = key => {
    return event => {
      let state = {};

      state[key] = event.target.value;
      this.setState(state);
    };
  };

  outsideClick = e => {
    if (this.state.showCalculationSection && !e.target.closest('.volume-calculator-dropdown')) {
      this.toggleCalculationSection();
    }
  };

  saveVolume = vol => {
    if (this.props.onChange) {
      this.props.onChange({key: this.props.dataKey, value: parseInt(vol)});
    } else if (this.props.onBlur) {
      this.props.onBlur({key: this.props.dataKey, value: parseInt(vol)});
    }
  };

  toggleCalculationSection = () => {
    this.setState({showCalculationSection: !this.state.showCalculationSection});
  };

  toggleSlopingSides = () => {
    this.setState({slopingSides: !this.state.slopingSides});
  };

  getCondition = val => {
    const {isCA} = this.state;

    if (this.props.poolType === 1) { // Pool
      return isCA ? !!val && val >= 100 && val <= 999000 : !!val && val >= 500 && val <= 999999;
    } else if (this.props.poolType === 2) {  // Spa
      return isCA ? !!val && val >= 350 && val <= 19000 : !!val && val >= 100 && val <= 9999;
    }

    return isCA ? !!val && val >= 100 && val <= 999000 : !!val && val >= 400 && val <= 9999;
  };

  getErrorMessage = () => {
    const {isCA} = this.state;
    let {formatMessage} = this.props.intl;
    let high = 0;
    let low = 0;
    let system = '';
    let volume = isCA ?
      <FormattedMessage id='quick-calcs.volume.litres'/> :
      <FormattedMessage id='quick-calcs.volume.gals'/>;

    if (this.props.poolType === 1) { // Pool
      high = isCA ? 999000 : 999999;
      low = isCA ? 100 : 500;
      system = <FormattedMessage id='general.pool'/>;
    } else if (this.props.poolType === 2) {  // Spa
      high = isCA ? 19000 : 9999;
      system = <FormattedMessage id='general.spa'/>;
      low = isCA ? 350 : 100;
    } else if (this.props.poolType === 3) {  // Swim Spa
      high = isCA ? 999000 : 9999;
      system = <FormattedMessage id='general.swim.spa'/>;
      low = isCA ? 100 : 400;
    }

    return <FormattedMessage id='quick-calcs.volumes.error' values={{system, low, high, volume}}/>;
  };

  render() {
    const {isCA} = this.state;
    let volume = this.props.volume;
    let {formatMessage} = this.props.intl;

    if (this.props.poolType !== 1) {
      return <div style={{position: 'relative', width: '100%'}}>
        <EditableTextField type='number'
                           dataKey='volume'
                           onChange={this.handleChange}
                           value={this.state.volume}
                           editMode={this.props.editMode}
                           ref={r => this.input = r}
                           validate={this.getCondition}
                           validateMessage={this.getErrorMessage()}
                           required={true}
                           beforeFocus={() => this.props.beforeFocus && (location.hash = path.join(location.hash, '..', 'details'))}
                           group={this.props.group}
                           formatted={volume ?
                             volume + ' ' + (isCA ? formatMessage({id: 'quick-calcs.volume.litres'}) : formatMessage({id: 'quick-calcs.volume.gals'})) + '.' :
                             '(' + formatMessage({id: 'general.none'}) + ')'
                           }
                           onBlur={this.handleBlur('volume')}/>
      </div>;
    }

    return <div className='volume-calculator'>
      <div style={{width: '100%', position: 'relative'}}>
        <EditableTextField type='number'
                           dataKey='volume'
                           onChange={this.handleChange}
                           ref={r => this.input = r}
                           value={this.state.volume}
                           editMode={this.props.editMode}
                           validate={this.getCondition}
                           validateMessage={this.getErrorMessage()}
                           group={this.props.group}
                           beforeFocus={() => this.props.beforeFocus && (location.hash = path.join(location.hash, '..', 'details'))}
                           required={true}
                           formatted={volume ?
                             volume + ' ' + (isCA ? formatMessage({id: 'quick-calcs.volume.litres'}) : formatMessage({id: 'quick-calcs.volume.gals'})) + '.' :
                             '(' + formatMessage({id: 'general.none'}) + ')'
                           }
                           onBlur={this.handleBlur('volume')}/>
        {this.props.editMode ?
          <button className='btn btn-primary'
                  onClick={this.toggleCalculationSection}
                  title={formatMessage({id: 'system.details.select.calculate'})}
                  style={{
                    display: 'inline-block',
                    width: '45%',
                    float: 'right',
                  }}>{formatMessage({id: 'quick-calcs.calculate'})}
          </button> :
          null
        }
      </div>
      {this.calculationSection()}
    </div>;
  }
}

export default injectIntl(VolumeCalculator);
